export type GtmSignInLocations = {
  event_location: 'checkout' | 'nav_bar_popup' | 'account' | 'unknown'
}

export const mapUrlToEventLocation = (
  url: string,
): GtmSignInLocations['event_location'] => {
  if (url.includes('checkout')) return 'checkout'
  if (url.includes('products')) return 'nav_bar_popup'
  if (url.includes('product')) return 'nav_bar_popup'
  if (url.includes('account')) return 'account'

  return 'unknown'
}
